import CustomGroupReport from './custom-group-report.vue'
export default CustomGroupReport
